import React from 'react';
import moment from 'moment';
import NoDataMsg from 'library/noData';

const Body = ({ inventoryMovement, inventoryMovementProductInfo, endDate, beginDate }) => (
    <React.Fragment>
        {inventoryMovementProductInfo &&
            <div className="row m-0 mb-1  text-center"  >
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left">
                    <h3>Product Name: {inventoryMovementProductInfo.productName}</h3>
                    <h3>Product SKU: {inventoryMovementProductInfo.sku}</h3>
                    <h3>Open Inventory: {inventoryMovementProductInfo.openInventory}</h3>
                    <h3>Close Inventory: {inventoryMovementProductInfo.closeInventory}</h3>
                    {inventoryMovementProductInfo.openOrdersId && inventoryMovementProductInfo.openOrdersId.length > 0 && <h3>Open Order Ids: {inventoryMovementProductInfo.openOrdersId.join(", ")}</h3>}
                </div>
            </div>
        }
        {
            inventoryMovement.length <= 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                //If there's DATA
                <div>
                    <div className="row m-0">
                        <div className="text-center list_header">
                            {beginDate ?
                                <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                    {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                : ""}
                        </div>
                    </div>
                    {
                        inventoryMovement.length > 0 &&
                        <div className="table-responsive">
                            {
                                inventoryMovement.map((item, index) => {
                                    return (
                                        <div className="row m-0 mb-2" key={index}>
                                            <div className="col-lg-12 title_th">
                                            </div>{/* row - Date */}
                                            <div className="col-lg-12 text-center daily_cash">
                                                <div className="row col-lg-12 col-md-12 col-sm-12 col-xs-12 m-0 p-0">
                                                    <div className="col-lg-3 col-md-4 col-sm-4 col-xs-6">
                                                        <label>Date/Time</label>
                                                        <h3 className="m-0 grey-text">{(moment(item.logDate).format('MMMM Do YYYY, h:mm:ss a'))}</h3>
                                                    </div>
                                                    <div className="col-lg-3 col-md-4 col-sm-4 col-xs-6">
                                                        <label>Employee name</label>
                                                        <h3 className="m-0 grey-text">{(item.employeeName)}</h3>
                                                    </div>
                                                    <div className="col-lg-2 col-md-4 col-sm-4 col-xs-6">
                                                        <label>Action</label>
                                                        <h3 className="m-0 grey-text">{item.action}</h3>
                                                    </div>
                                                    <div className="col-lg-2 col-md-4 col-sm-4 col-xs-6">
                                                        <label>Movement Reason</label>
                                                        <h3 className="m-0 grey-text">{item.reasonText}</h3>
                                                    </div>
                                                    <div className="col-lg-2 col-md-4 col-sm-4 col-xs-6">
                                                        <label>Qty Change</label>
                                                        <h3 className="m-0 grey-text">{(item.quantityToChange)}</h3>
                                                    </div>

                                                </div>
                                                <div className="row col-lg-12 col-md-4 col-sm-12 col-xs-12 ptb-1">
                                                    <div className="col-lg-3 col-md-4 col-sm-4 col-xs-6">
                                                        <label>Inventory Change Warehouse Name</label>
                                                        <h3 className="m-0 grey-text">{item.inventoryChangeWarehouse}</h3>
                                                    </div>
                                                    <div className="col-lg-3 col-md-4 col-sm-4 col-xs-6 ptb-1">
                                                        <label>All Warehouses Prev Qty</label>
                                                        <h3 className="m-0 grey-text">{(item.allWarehousesPreviousInventory)}</h3>
                                                    </div>
                                                    <div className="col-lg-2 col-md-4 col-sm-4 col-xs-6 ptb-1">
                                                        <label>All Warehouses New Qty</label>
                                                        <h3 className="m-0 grey-text">{(item.allWarehousesNewInventory)}</h3>
                                                    </div>
                                                    <div className="col-lg-2 col-md-4 col-sm-4 col-xs-6 ptb-1">
                                                        <label>Lot number</label>
                                                        <h3 className="m-0 grey-text">{item.packageReference}</h3>
                                                    </div>
                                                    <div className="col-lg-2 col-md-4 col-sm-4 col-xs-6  ptb-1">
                                                        <label>Inventory Change Page</label>
                                                        <h3 className="m-0 grey-text">{item.placeOfInventoryChange}</h3>
                                                    </div>
                                                </div>
                                                <div className="row col-lg-12 col-md-12 col-sm-12 col-xs-12 ptb-1">
                                                    {
                                                        item.orderId > 0 && (
                                                            <div className="col-lg-3 col-md-4 col-sm-4 col-xs-6">
                                                                <label>Order Id</label>
                                                                <h3 className="m-0 grey-text">{(item.orderId)}</h3>
                                                            </div>
                                                        )
                                                    }
                                                    {
                                                        item.orderProductReason && (
                                                            <div className="col-lg-3 col-md-4 col-sm-4 col-xs-6">
                                                                <label>Order Product Reason</label>
                                                                <h3 className="m-0 grey-text">{(item.orderProductReason)}</h3>
                                                            </div>
                                                        )
                                                    }
                                                    {
                                                        item.otherReductionReason && (
                                                            <div className="col-lg-1 col-md-4 col-sm-4 col-xs-6">
                                                                <label>Other Reduction Reason</label>
                                                                <h3 className="m-0 grey-text">{(item.otherReductionReason)}</h3>
                                                            </div>
                                                        )
                                                    }
                                                    {
                                                        item.notes && (
                                                            <div className="col-lg-1 col-md-4 col-sm-4 col-xs-6">
                                                                <label>Notes</label>
                                                                <h3 className="m-0 grey-text">{(item.notes)}</h3>
                                                            </div>
                                                        )
                                                    }
                                                    {
                                                        item.purchaseOrderId > 0 && (
                                                            <div className="col-lg-1 col-md-4 col-sm-4 col-xs-6">
                                                                <label>Purchase Order Id</label>
                                                                <h3 className="m-0 grey-text">{(item.purchaseOrderId)}</h3>
                                                            </div>
                                                        )
                                                    }
                                                    {
                                                        item.transferFromBranchId > 0 && (
                                                            <div className="col-lg-1 col-md-4 col-sm-4 col-xs-6">
                                                                <label>Transfer From Branch Id</label>
                                                                <h3 className="m-0 grey-text">{(item.transferFromBranchId)}</h3>
                                                            </div>
                                                        )
                                                    }
                                                    {
                                                        item.transferToBranchId > 0 && (
                                                            <div className="col-lg-1 col-md-4 col-sm-4 col-xs-6">
                                                                <label>Transfer To Branch Id</label>
                                                                <h3 className="m-0 grey-text">{(item.transferToBranchId)}</h3>
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            </div>{/* Column Icons */}
                                        </div>
                                    );
                                })
                            }
                        </div>
                    }
                </div>
        }
    </React.Fragment>
);

export default Body;